export const check24WidgetMixin = {
    data() {
        return {
            check24WidgetEnabled: false,
            check24WidgetUrl: null,
            check24WidgetId: 'check-24-iframe',
            check24WidgetMessageHandler: null,
            check24WidgetBaseUrl:
                'https://compado.tierkrankenversicherungen.check24.de',
            check24WidgetDomains: ['top-haustier-krankenversicherung.de'],
            check24WidgetCategories: [
                'katzenversicherung',
                'hundeversicherung',
            ],
        };
    },
    created() {
        this.$eventHub.$on('partner-list-loaded', async () => {
            await this.initCheck24Widget();
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('partner-list-loaded');
        this.removeCheck24WidgetListener();
    },
    methods: {
        async initCheck24Widget() {
            this.check24WidgetEnabled = await this.isCheck24WidgetEnabled();
            if (this.check24WidgetEnabled) {
                this.attachCheck24WidgetListener();
                this.check24WidgetUrl = await this.getCheck24WidgetUrl();
            }
        },
        async isCheck24WidgetEnabled() {
            const hostName = this.$globalConstants.host['name'];
            const isBot = window['__traffic_source__'] === 'bot';
            const categorySlug = await this.getCategorySlug();
            return (
                this.check24WidgetDomains.includes(hostName) &&
                this.check24WidgetCategories.includes(categorySlug) &&
                !isBot
            );
        },
        async getCheck24WidgetUrl() {
            const hash = await this.getClickOutHash();
            const categorySlug = await this.getCategorySlug();
            if (categorySlug === 'hundeversicherung') {
                return `${this.check24WidgetBaseUrl}?animal=dog&wpset=compado_hkv_format1&srcclkid=${hash}`;
            }
            if (categorySlug === 'katzenversicherung') {
                return `${this.check24WidgetBaseUrl}?animal=cat&wpset=compado_kkv_format1&srcclkid=${hash}`;
            }
            return null;
        },
        async getClickOutHash() {
            if (this.rankingTablePartners.length < 1) return '';

            const partner = this.rankingTablePartners[0];
            let gotoLink = partner['api_clickout'];

            const url = new URL(gotoLink, window.location.origin);
            url.searchParams.set('no_redirect', 'true');

            try {
                const response = await window.axios.get(url.toString());

                if (response.data) {
                    const redirectUrl = new URL(response.data);
                    return (
                        redirectUrl.searchParams.get('compclid') ||
                        redirectUrl.searchParams.get('r') ||
                        redirectUrl.searchParams.get('tid') ||
                        ''
                    );
                }
            } catch (error) {
                console.error('Error fetching click-out hash:', error);
            }

            return '';
        },
        attachCheck24WidgetListener() {
            this.check24WidgetMessageHandler = (event) => {
                const element = document.getElementById(this.check24WidgetId);
                if (
                    element &&
                    typeof event.data.height === 'number' &&
                    event.data.height > 0
                ) {
                    element.style.minHeight = `${event.data.height + 100}px`; // extra 100 pixel to avoid scrollbar
                }
            };
            window.addEventListener(
                'message',
                this.check24WidgetMessageHandler
            );
        },
        removeCheck24WidgetListener() {
            if (!this.check24WidgetMessageHandler) return;
            window.removeEventListener(
                'message',
                this.check24WidgetMessageHandler
            );
        },
    },
};
